import script from "./WhitePassCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhitePassCard.vue?vue&type=script&setup=true&lang=ts"

import "./WhitePassCard.vue?vue&type=style&index=0&id=502c963a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502c963a"]])

export default __exports__